var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 56,
    viewBox: "0 0 69 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30033 45.994L28.4504 3.02389C31.4055 -1.00796 37.5928 -1.00796 40.5479 3.02389L67.698 45.994C70.5607 49.8466 67.698 55.312 62.8036 55.312H6.28708C1.30033 55.2224 -1.56243 49.8466 1.30033 45.994Z",
    fill: "url(#paint0_linear_519_4216)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4999 14.0249C31.9128 14.0249 29.9006 16.2992 30.0922 18.969L31.5295 34.9879C31.6253 36.57 32.9668 37.8554 34.4999 37.8554C36.033 37.8554 37.3744 36.57 37.4703 34.9879L38.9075 18.969C39.0992 16.2003 37.087 14.0249 34.4999 14.0249Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5002 40.8218C32.5839 40.8218 31.0508 42.4039 31.0508 44.3815C31.0508 46.3592 32.5839 47.9413 34.5002 47.9413C36.4166 47.9413 37.9497 46.3592 37.9497 44.3815C37.9497 42.4039 36.4166 40.8218 34.5002 40.8218Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_519_4216",
    x1: 0.131146,
    y1: 29.1103,
    x2: 68.8501,
    y2: 29.1103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD784C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD561F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlarm);
export default __webpack_public_path__ + "static/media/errorAlarm.e4d3237addb9028a737fd85c8268ceeb.svg";
export { ForwardRef as ReactComponent };